import { ProviderManager } from '@ankr.com/provider';
import { IProvidersMap } from '@ankr.com/provider/src/providerManager/ProviderManager';
import { Mutex } from 'async-mutex';
import { ThemeColors } from 'web3modal';

import { CUSTOM_RPC_URLS } from './consts';

export const web3ModalTheme: ThemeColors = {
  background: 'rgb(255,255,255)',
  main: 'rgb(137, 137, 137)',
  secondary: 'rgb(137, 137, 137)',
  border: 'rgba(195,195,195,0.14)',
  hover: 'rgb(239, 239, 239)',
};

const mutex = new Mutex();
let manager: ProviderManager<IProvidersMap>;

export async function getProviderManager(): Promise<
  ProviderManager<IProvidersMap>
> {
  await mutex.runExclusive(() => {
    if (manager) {
      return manager;
    }

    manager = new ProviderManager(web3ModalTheme, undefined, CUSTOM_RPC_URLS);
  });

  return manager;
}
